module.exports = __webpack_public_path__ + "fonts/gumb.0628bd054b606ebdd26e.svg";